import React from 'react';
import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';

export const CheckboxChipGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 12px;
  grid-row-gap: 12px;
`;

const CheckboxChipRoot = styled(Text)<{ checked: boolean }>`
  ${({ theme, checked }) => `
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacing(1.5)};
    border-radius: ${theme.borderRadius.large};
    padding: ${theme.spacing(1.5, 3, 1.5, 1)};
    background-color: ${checked ? theme.colors.neutrals.grey10 : theme.colors.neutrals.white};
    position: relative;
    svg {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
    }

    &:after {
      content: '';
      border-radius: ${theme.borderRadius.large};
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: ${checked ? 2 : 1}px solid ${checked ? theme.colors.neutrals.grey1 : theme.colors.neutrals.grey6};
      pointer-events: none;
    }
  `}
`;

interface CheckboxChipProps {
  label: string | React.ReactNode;
  icon: React.ReactNode;
  checked: boolean;
  onClick: () => void;
}

export const CheckboxChip: React.FC<CheckboxChipProps> = props => {
  const { label, icon, checked, onClick } = props;

  return (
    <CheckboxChipRoot checked={checked} onClick={onClick}>
      {icon}
      {label}
    </CheckboxChipRoot>
  );
};
